import axios from 'axios'
import qs from 'qs'
import { Toast } from 'mint-ui';
// import $ from 'jquery';
// import Zepto from '../../static/zepto'
// import device from '../../static/device'

let requestChannel  = "";
if(location.host.indexOf("minner") > -1 || location.host.indexOf("localhost") > -1){
  axios.defaults.baseURL = `//msinner.jr.jd.com${requestChannel}`;
}else{
  axios.defaults.baseURL = `//ms.jr.jd.com${requestChannel}`;
}

axios.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  } else {
    config.params = config.params || {}
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (res) {
  let {resultCode,resultMsg,resultData} = res.data;
  
  return {
    resultCode:resultCode,
    resultData:resultData
  }
}, function (error) {
  // Do something with response error
  // Toast("出错了！");
  console.error("error===",error);
  return Promise.reject(error)
})

// 让ajax请求头携带cookie
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
export default axios



// WEBPACK FOOTER //
// ./src/api/axios.conf.js